<template>
    <div>
        <OrderedListRecurring
            row="2"
            :list="$tm('page.apix_drive.source.settings')"
        >
            <template v-slot:default="props">
                <img
                    :src="images['img' + (props.index + 1)]"
                    class="image_list"
                />
            </template>
        </OrderedListRecurring>
    </div>
</template>

<script setup>
import { onMounted } from "vue";
import OrderedListRecurring from "../Recurring/OrderedListRecurring.vue";
import img1 from "@/assets/apix-drive/source/sett-1source.png";
import img2 from "@/assets/apix-drive/source/sett-2source.png";
import img3 from "@/assets/apix-drive/source/sett-3source.png";
import img4 from "@/assets/apix-drive/source/sett-4source.png";
import img5 from "@/assets/apix-drive/source/sett-5source.png";
import img6 from "@/assets/apix-drive/source/sett-6source.png";
import img7 from "@/assets/apix-drive/source/sett-7source.png";
import img8 from "@/assets/apix-drive/source/sett-8source.png";

const images = { img1, img2, img3, img4, img5, img6, img7, img8 };

import { useI18n } from "vue-i18n";
const { t } = useI18n();

defineProps({
    windowSize: {
        type: Number,
        require: true,
    },
});

onMounted(() => {
    window.$t = t;
});
</script>

<style lang="scss" scoped>
@use "@/styles/pages/instruction.scss";

.image_list {
    margin: 15px 0;
    width: 100%;
    /* border-radius: 11px; */
}
</style>
